module.exports = __webpack_public_path__ + "img/result-detail-communication-outleft01.abce9008.svg";